import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Link } from 'react-router-dom';
import { Auth } from "aws-amplify";   // Logging out
import { ToastsContainer, ToastsStore, ToastsContainerPosition } from 'react-toasts';

import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend
} from "recharts";

import * as envKeys from "../../ENV";

import {
  getAffiliateDashboardUserAction,
  getBarGraphDataForDashboard,
  getAffiliateUser,
  getSettlementListByAffiliateType,
  logoutUser, clearDataEmail    // Logging out
} from "../../Actions/actions";

const styles = {
  root: {
    flexGrow: 1,
  },
  flex: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  tabsRoot: {
    borderBottom: '4px solid #ef6262',
  },
  tabsIndicator: {
    backgroundColor: '#1890ff',
  },

  tabSelected: {},
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: '#000',
    },
  },
};


class partnerDashboard extends React.Component {
  state = {
    userId: localStorage.getItem("userId"),
    GetAffiliateUserData: {},
    isLoader: false,
    settlementId: null,
    chartDataGraph: [],
  };

  componentDidMount() {
    const { userId } = this.state
    const { getAffiliateDashboardUserAction, getAffiliateUser } = this.props
    getAffiliateDashboardUserAction({ userId });
    getAffiliateUser(userId);
    this.fetchBarGraph();

  }


  fetchData = () => {
    const { affiliateType, userId } = this.state
    const { getSettlementListByAffiliateType } = this.props
    getSettlementListByAffiliateType({
      affiliateType: affiliateType,
      userId,
      pageNumber: 1,
      pageSize: 10,
      searchKeyword: '',
      sortBy: ''
    });
  }

  fetchBarGraph = () => {
    const { userId, settlementId } = this.state
    const { getBarGraphDataForDashboard } = this.props
    getBarGraphDataForDashboard({ userId, settlementId });

  }

  componentDidUpdate() {
    const {
      GetAffiliateUser,
      barGraphData,
    } = this.props.data;
    const {
      GetAffiliateUserData,
      barGraphData1,
    } = this.state;
    if (GetAffiliateUserData !== GetAffiliateUser) {
      // if (GetAffiliateUser && GetAffiliateUser.affiliateType !== undefined) {
        this.setState({
          // affiliateType: GetAffiliateUser.affiliateType,
          GetAffiliateUserData: GetAffiliateUser,
        }, () => {
          // if (GetAffiliateUser.affiliateType && GetAffiliateUser.affiliateType !== "") {
            this.fetchData()
          // }
        });
      // }
    }

    if (barGraphData && barGraphData.status !== "NOT_FOUND") {
      if (barGraphData1 !== barGraphData) {
        if (barGraphData.barGraphDtos !== undefined) {
          const dataBarGraph = [];


             barGraphData && barGraphData.barGraphDtos.map((barGraphDtos) => {
            dataBarGraph.push({
              name: barGraphDtos.monthLabel,
              Users: barGraphDtos.users,
              Enrollments: barGraphDtos.enrollments
            });
            return true
          })

          // for (
          //   let index = 0;
          //   index <= barGraphData.dataSetDtos[1].data.length;
          //   index++
          // ) {
          //   dataBarGraph.push({
          //     name: barGraphData.labels[index],
          //     Users: barGraphData.dataSetDtos[0].data[index],
          //     Enrollments: barGraphData.dataSetDtos[1].data[index]
          //   });
          // }
          this.setState({
            chartDataGraph: dataBarGraph,
            barGraphData1: barGraphData
            // settlementUserIdAffiliateData2:settlementUserIdAffiliateData1.userDto
          });
        }
      }
    }
  }

  handleSession = async () => {                   // Logging out
    await localStorage.clear();
    Auth.signOut().then(async () => {
      await this.props.logoutUser();
      this.props.clearDataEmail();
      this.props.history.push("/");
    });
  }

  render() {
    if(typeof this.props.data.GetAffiliateUser === "undefined"){		 //For  Logging out
      this.handleSession();	                                         //
    }     
    const { data: { affiliateDashboardData, settlementDataAffiliate, barGraphData, profileName } } = this.props
    const { chartDataGraph, settlementId } = this.state
    return (
      <div className="p-overview">
        {console.log('barGraphData', barGraphData)}
        <div className="p-overview-heading">
          <h3 className="p-h3">Welcome <span className="p-sub-h3">{profileName && profileName}</span></h3>
          <h4 className="p-h4">Performance</h4>
        </div>
        <div className="p-overview-scorecard">
          {this.state.GetAffiliateUserData && this.state.GetAffiliateUserData.affiliateType != "Consumer"     //Logging out
          ?
          <div className="p-card p-card-blue monthly-score">
          <h2>${affiliateDashboardData && affiliateDashboardData.partnerMMR && affiliateDashboardData.partnerMMR.partnerMMR ? affiliateDashboardData.partnerMMR.partnerMMR.toFixed(2) : 0}</h2>
          <p>Monthly Recuring Revenue</p>
          <label>*Includes annual subscriptions</label>
        </div>
          :
          ""
          }

          <div className="p-card  full-score p-d-flex">
            <div className="p-performance-users p-border-right">
              <h3 className="p-h3 p-font-bold">{affiliateDashboardData && affiliateDashboardData.otherValuesMap && affiliateDashboardData.otherValuesMap.Total_Refered_Users}</h3>
              <label className="text-uppercase p-font-bold">Total Users</label>
              <div className="p-cost-list p-plan-users-cost">
                <div className="p-cost-item">
                  <h4 className="p-h4 p-font-medium">{affiliateDashboardData && affiliateDashboardData.finalMap && affiliateDashboardData.finalMap.planMap && affiliateDashboardData.finalMap.planMap.Basic ? affiliateDashboardData.finalMap.planMap.Basic : 0}</h4>
                  <label className="text-uppercase p-font-bold">Basic</label>
                </div>
                <div className="p-cost-item">
                  <h4 className="p-h4 p-font-medium">{affiliateDashboardData && affiliateDashboardData.finalMap && affiliateDashboardData.finalMap.planMap && affiliateDashboardData.finalMap.planMap.Flex ? affiliateDashboardData.finalMap.planMap.Flex : 0}</h4>
                  <label className="text-uppercase p-font-bold">Flex</label>
                </div>
                <div className="p-cost-item">
                  <h4 className="p-h4 p-font-medium">{affiliateDashboardData && affiliateDashboardData.finalMap && affiliateDashboardData.finalMap.planMap && affiliateDashboardData.finalMap.planMap.Premium ? affiliateDashboardData.finalMap.planMap.Premium : 0}</h4>
                  <label className="text-uppercase p-font-bold">Premium</label>
                </div>
              </div>
            </div>
            <div className="p-performance-users p-left">
              <h3 className="p-h3 p-font-bold">{affiliateDashboardData && affiliateDashboardData.otherValuesMap && affiliateDashboardData.otherValuesMap.Total_Enroll_Settlements}</h3>
              <label className="text-uppercase p-font-bold">Total Enrollments</label>
              <div className="p-cost-list">
                <div className="p-cost-item">
                  <h4 className="p-h4 p-font-bold">{affiliateDashboardData && affiliateDashboardData.otherValuesMap && isNaN((affiliateDashboardData.otherValuesMap.Total_Enroll_Settlements / affiliateDashboardData.otherValuesMap.Total_Refered_Users)) === false ? (affiliateDashboardData.otherValuesMap.Total_Enroll_Settlements / affiliateDashboardData.otherValuesMap.Total_Refered_Users).toFixed(2) : 0}</h4>
                  <label className="text-uppercase p-font-bold">Avg. Enrollments per user</label>
                </div>
              </div>

            </div>
          </div>

        </div>
        <div className="p-overview-Settlements">
          <div className="table-filter">
            <h3 className="table-filter-tittle">Settlements  <span>{settlementDataAffiliate && settlementDataAffiliate.result && (<span>({settlementDataAffiliate.result.totalCount})</span>)}</span>
            </h3>
          </div>
          <div className="p-overview-Settlements-card p-card">
            <div className="p-overview-Settlements-left">
              <div className="p-select">
                <select className='p-ro-select' name="settlementId" placeholder="Select an settlements" value={settlementId} onChange={(event) => {
                  this.setState({
                    settlementId: event.target.value
                  }, () => {
                    this.fetchBarGraph()
                  })
                }} >
                  <option className="p-option-style" value=''>All Settlements</option>
                  {
                    settlementDataAffiliate && settlementDataAffiliate.result && settlementDataAffiliate.result.totalSettlementForDropdown.map((categoryList, index) => (
                      <option className="p-option-style" key={index} value={categoryList.settlementId}>{categoryList.shortName}</option>
                    ))
                  }
                </select>
              </div>
              <div className="p-cost-list">
                <div className="p-cost-item">
                  <h4 className="p-h4 p-font-bold">{(settlementId === null || settlementId === "") ? affiliateDashboardData && affiliateDashboardData.otherValuesMap && affiliateDashboardData.otherValuesMap.Total_Enroll_Settlements : barGraphData && barGraphData.totalEnrollments ? barGraphData.totalEnrollments : 0}</h4>
                  <label className="text-uppercase p-font-medium">Enrollments</label>
                </div>
                {/* {(settlementId !== null && settlementId !== "") && <div className="p-cost-item">
                  <h4 className="p-h4 p-font-bold">${barGraphData && barGraphData.partnerMMR}</h4>
                  <label className="text-uppercase p-font-medium">MRR</label>
                </div>} */}


              </div>
              {(settlementId !== null && settlementId !== "") && <div className="p-cost-item">
                <Link to={`/settlementAffiliate/enrollment-list/${settlementId}`} className=" view-settlement-link p-font-medium">View Settlement</Link>
              </div>}
            </div>
            <div className={barGraphData && barGraphData.length === 0 ? "p-overview-Settlements-right no-record-graph" : "p-overview-Settlements-right"}>
              {barGraphData && barGraphData.length === 0 ? (
                <div>
                  No Data
                </div>) : (
                  <div className="settlement-graph-overview">
                    <div className="graph-heading">Users + Enrollments</div>
                    <BarChart width={700} height={270} data={chartDataGraph}>
                      <CartesianGrid vertical={false} />

                      <XAxis dataKey="name" />
                      <YAxis />
                      <Tooltip />
                      <Legend iconType="circle" />
                      <Bar maxBarSize={8} dataKey="Users" fill="#19d490" radius={20} />
                      <Bar maxBarSize={8} dataKey="Enrollments" fill="#e220b2" radius={20} />
                    </BarChart>
                  </div>
                )}
            </div>


          </div>
        </div>
        <div className="p-overview-partner-url-outer">
          <div className="table-filter">
            <h3 className="table-filter-tittle">Partner URLs  <span>{affiliateDashboardData && affiliateDashboardData.affiliateLinkDtoList && `(${affiliateDashboardData.affiliateLinkDtoList.length})`}</span>
            </h3>
          </div>
          <div >
              <h5 className="p-head5">Link title</h5>
              <h5 className="p-head5">Link Status</h5>
          </div> 
          <div className="p-overview-partner-url bgWhite">

            {affiliateDashboardData && affiliateDashboardData.affiliateLinkDtoList && affiliateDashboardData.affiliateLinkDtoList.map((item1, index) => (
              <div key={index} className="p-overview-urls">
                
                <div className="p-overview-urls-data p-d-flex">
                  {item1.identifierName ? (<span className="topBlock">{item1.identifierName}</span>) : (<span className="p-blue-link"> {envKeys.REACT_APP_FRONTEND_URL}/signup/{item1.affiliateKey} </span>)}
                  {item1.isActive === 0 ?
                    <p className="p-head5 marginBlock">Disabled</p> : 
                    <p className="p-head5 marginBlock">Enabled</p>}
                  
                  <CopyToClipboard
                    className="p-black-btn"
                    text={`${envKeys.REACT_APP_FRONTEND_URL}/signup/${item1.affiliateKey}`}
                    onCopy={() => ToastsStore.info("Link copied!", 5000, "toast-error-msg")}
                  >
                    <a className="p-black-btn">
                      Copy Link
                  </a>
                  </CopyToClipboard>
                  <ToastsContainer className="toast-error-msg"
                    position={ToastsContainerPosition.TOP_CENTER}
                    lightBackground store={ToastsStore} />

                  <label>{item1.affiliateLinkeSize} users</label>
                </div>
              </div>

            ))}

            {affiliateDashboardData && affiliateDashboardData.affiliateLinkDtoList.length === 0 ? 'No Partner URLs yet' : ''}
            {/* <a href="javascript:;">collectively/clientname/linkname</a>
            <a className="p-black-btn" href="javascript:;">Copy Link</a> */}
          </div >
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  data: state.data,
});


const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getAffiliateDashboardUserAction,
      getBarGraphDataForDashboard,
      getAffiliateUser,
      getSettlementListByAffiliateType,
      logoutUser, clearDataEmail   // Logging out
    },
    dispatch
  );
export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(partnerDashboard));
